// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var _a;
export var PublishStatus;
(function (PublishStatus) {
    PublishStatus["Void"] = "VOID";
    PublishStatus["Started"] = "STARTED";
    PublishStatus["StartedLoading"] = "STARTED_LOADING";
    PublishStatus["Paused"] = "PAUSED";
    PublishStatus["PausedLoading"] = "PAUSED_LOADING";
    PublishStatus["Stopped"] = "STOPPED";
    PublishStatus["StoppedLoading"] = "STOPPED_LOADING";
    PublishStatus["Published"] = "PUBLISHED";
    PublishStatus["PublishedLoading"] = "PUBLISHED_LOADING";
    PublishStatus["Generated"] = "GENERATED";
    PublishStatus["GeneratedLoading"] = "GENERATED_LOADING";
    PublishStatus["Exported"] = "EXPORTED";
})(PublishStatus || (PublishStatus = {}));
export var nextStatus = function (statusValue) {
    var statusIndex = Object.values(PublishStatus).indexOf(statusValue);
    return Object.values(PublishStatus)[statusIndex + 1];
};
export var ElectionEventStatus;
(function (ElectionEventStatus) {
    ElectionEventStatus["Open"] = "OPEN";
    ElectionEventStatus["Paused"] = "PAUSED";
    ElectionEventStatus["Closed"] = "CLOSED";
    ElectionEventStatus["NotStarted"] = "NOT_STARTED";
})(ElectionEventStatus || (ElectionEventStatus = {}));
export var MAP_ELECTION_EVENT_STATUS_PUBLISH = (_a = {},
    _a[ElectionEventStatus.NotStarted] = PublishStatus.Void,
    _a[ElectionEventStatus.Open] = PublishStatus.Started,
    _a[ElectionEventStatus.Paused] = PublishStatus.Paused,
    _a[ElectionEventStatus.Closed] = PublishStatus.Stopped,
    _a);
